<template>
    <section class="section section-lg section-shaped overflow-hidden my-0">
        <div class="shape  shape-default shape-skew" style="background: #002A46">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0 pb-lg">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-5 mb-5 mb-lg-0">
                    <h1 class="text-white font-weight-light">About Us</h1>
                    <p class="lead text-white mt-4">D.Y.D. focuses on teaching music artists about the business side of the industry while also assisting them with music videos, social media presence, legal entities, etc.  </p>
			<router-link slot="brand" class="nav-link" to="/about">
               <base-button type="secondary">Learn More</base-button> 
            </router-link>  
                </div>
                <div class="col-lg-6 mb-lg-auto">
                    <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <!-- Text slides with image -->
							<b-carousel-slide img-src="img/theme/Fixed/secondphoto.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/theme/Fixed/IMG_2607.jpg"></b-carousel-slide>
							<b-carousel-slide img-src="img/theme/Fixed/pag-1.jpg"></b-carousel-slide>
							<b-carousel-slide img-src="img/theme/Fixed/candid_9.png"></b-carousel-slide>
							<b-carousel-slide img-src="img/theme/Fixed/candid_3.png"></b-carousel-slide>
                            <b-carousel-slide img-src="img/theme/Fixed/firstphoto.jpg"></b-carousel-slide>
							
                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue";
import { BCarouselSlide } from "bootstrap-vue";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
</style>
